import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5c9b9ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field-container" }
const _hoisted_2 = {
  key: 0,
  class: "field-name",
  for: "input-field-text"
}
const _hoisted_3 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass({
            'reset-icon-wrapper': true,
          })
}
const _hoisted_4 = {
  key: 0,
  class: "empty-option"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "advise" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'form-group': true,
      'input-is-invalid': !!_ctx.validation_message,
      'input-readonly': _ctx.readonly,
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass({
          'input-field': true,
          'input-not-empty': _ctx.show_options || _ctx.patient,
          'manual-focus': _ctx.manual_focus,
        })
      }, [
        (_ctx.label)
          ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_ctx.label), 1))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          ref: "search_text",
          onFocusin: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show())),
          class: _normalizeClass({ 'horario-picker': true }),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.text_search) = $event)),
          autocomplete: "off"
        }, null, 544), [
          [_vModelText, _ctx.text_search]
        ]),
        (_ctx.patient)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (!_ctx.readonly)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    class: "reset-icon",
                    icon: ['fa', 'times'],
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.reset()))
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass({
          'list-dropdown': true,
          'show-dowpdown': _ctx.show_options && !_ctx.readonly,
        })
      }, [
        (!_ctx.options?.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.empty_message), 1))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (pa) => {
          return (_openBlock(), _createElementBlock("span", {
            key: pa.id,
            class: _normalizeClass({ 'is-selected': _ctx.patient == pa }),
            onClick: ($event: any) => (_ctx.setSelected(pa))
          }, _toDisplayString(pa.name), 11, _hoisted_5))
        }), 128))
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (!!_ctx.validation_message)
        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
            key: 0,
            icon: "exclamation-circle"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("span", null, _toDisplayString(_ctx.validation_message), 1)
    ])
  ], 2))
}